import * as React from 'react';
import { useLocalStorageState } from '@toolpad/core';
import dayjs from 'dayjs';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

// preview-start
const DAYJS_CODEC = {
  parse: (dateString) => dayjs(dateString),
  stringify: (date) => date.toISOString(),
};

export default function DatePick() {
  const [value, setValue] = useLocalStorageState('custom-value', null, {
    codec: DAYJS_CODEC,
  });

  const onchangeDate = (newValue) => {
    setValue(newValue);
    console.log(newValue);
  };
  // ...
  // preview-end
  return (
    <div>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack direction="row" spacing={2} marginLeft={10}>
        <DatePicker
          value={value}
          onChange={onchangeDate}
        />
      </Stack>
    </LocalizationProvider>
    </div>
  );
}
